import { render, staticRenderFns } from "./gantt_chart.vue?vue&type=template&id=33955efa&lang=html&"
import script from "./gantt_chart.vue?vue&type=script&lang=js&"
export * from "./gantt_chart.vue?vue&type=script&lang=js&"
import style0 from "./gantt_chart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports